import { API } from 'src/apis/apiWrapper';
import { processResponse } from 'src/utils/api';

/**
 * Retrieves reference data from the backend for a given cbDomain.
 * 
 * For 'country' domain, the backend returns a transformed list of countries (TDropItem[]).
 * For all other domains (e.g., 'region', 'org-type', 'org-sub-type', 'inst-lvl',
 * 'school-sub-type', 'school-level'), the backend returns the raw cdRefList (IRefItem[]).
 * 
 * 
 */
export const getDomainV1 = async (cbDomain: string): Promise<any> => {
  console.log('getDomainV1 cbDomain = ', cbDomain);
  const response = await API.post('AiFormRequest', '/save?key=msRef', {
    body: {
      recordCategoryType: 'common',
      cbDomain: cbDomain,
    },
  });

  return processResponse(response)
};
